(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }    		
              var productslider=[];
              document.querySelectorAll('.product-carousel').forEach(function(Element,index){    
                let productid = Element.dataset.id;
                let outer_carousel = Element.closest('.carousel-rowouter');
                let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
                let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
                let swiperObject={
                  loop:eval(Element.dataset.loop),
                  spaceBetween: 20,
                  enabled:true,
                  freeMode: true,
                  breakpoints: {
                    0: {
                      slidesPerView: 2,
                      spaceBetween: 5,
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: 4,
                    }
                  },
                  navigation: {
                    nextEl:nextbutton,
                    prevEl:prevbutton,
                  },
                  scrollbar: {
                    el: ".swiper-scrollbar",
                  }
                };    
                productslider[productid]=new Swiper(Element,swiperObject);
              }); 
              if(typeof quickAddButton == 'function'){
              quickAddButton();
              }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
